/**
 * requestTimeoutMessage.ts — фраза человеку об истёкшем ожидании (WEB-2590).
 *
 * Вынесена из `requestTimeout.ts` (WEB-2696): реестр пределов импортируют все
 * файлы `src/api/*`, среди них `leads.ts` из публичной воронки, и словарь
 * ошибок кабинета через него попадал в первый экран покупателя. Фраза нужна
 * только общему клиенту кабинета (`client.ts`), поэтому живёт отдельно и
 * словарь тянет только он. Реэкспортировать её из `requestTimeout.ts` нельзя:
 * сторож `requestTimeoutMessage.test.ts` и сторож первого экрана
 * (`build-guards/publicEntry.build.web1988`) это поймают.
 */
import { errorsStrings } from '@/i18n/dictionaries/errors';
import { pickStrings } from '@/i18n/define';
import { OUTCOME_UNKNOWN_CONFIG_KEY } from './requestTimeout';

/**
 * Фраза человеку об истёкшем ожидании — на языке кабинета. Для денежного или
 * необратимого запроса (пометка из реестра в `error.config`) — «результат
 * неизвестен, сначала проверьте».
 */
export function requestTimeoutMessage(error?: unknown): string {
  const s = pickStrings(errorsStrings);
  const config =
    typeof error === 'object' && error !== null
      ? (error as { config?: Record<string, unknown> }).config
      : undefined;
  return config?.[OUTCOME_UNKNOWN_CONFIG_KEY] === true
    ? s.requestTimedOutOutcomeUnknown
    : s.requestTimedOut;
}
